import { render, staticRenderFns } from "./Manage.vue?vue&type=template&id=3ae65048&scoped=true"
import script from "./Manage.vue?vue&type=script&lang=js"
export * from "./Manage.vue?vue&type=script&lang=js"
import style0 from "./Manage.vue?vue&type=style&index=0&id=3ae65048&prod&lang=less&scoped=true"
import style1 from "./Manage.vue?vue&type=style&index=1&id=3ae65048&prod&lang=less"


/* normalize component */
import normalizer from "!../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "3ae65048",
  null
  
)

export default component.exports